import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import './RolesEditor.sass';

import React from 'react';
import Button from 'react-bootstrap-button-loader';
import CheckboxTree from 'react-checkbox-tree';

import addAbilityToOpenModal from '../../utilities/modalHOC';
import ConfirmDeletion from '../Modals/ConfirmDeletion/ConfirmDeletion';

class RolesEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedRole: null,
      roleName: '',

      checks: [],
      expanded: [],
    };
  }

  componentWillReceiveProps({ creating, deleting, roles, selectedRole }) {
    const was = this.props;

    if (was.creating && !creating && roles.length) {
      this.selectRole(roles[roles.length - 1].id);
    }

    if (was.deleting && !deleting) {
      this.props.toggleNewRole(false);
      this.setState({ selectedRole: null, roleName: '' });
    }

    if (this.props.selectedRole !== selectedRole && selectedRole.id) {
      this.props.updateChecks(
        selectedRole[this.props.permissionsAttribute].map(
          (permission) => permission.id,
        ),
      );
    }
  }

  selectRole = (roleId) => {
    const selectedRole = this.props.roles.find(
      (role) => role.id === Number(roleId),
    );

    if (selectedRole) {
      this.props.updateChecks(
        selectedRole[this.props.permissionsAttribute].map(
          (permission) => permission.id,
        ),
      );
      this.setState({
        selectedRole,
        roleName: selectedRole.name,
        addMode: false,
      });
    }
  };

  static convertPermissionsForTreeview = (permissions) => {
    if (!permissions || permissions.length === 0) return [];

    // Build a tree structure from permission names (e.g., "Accounts.Students.Manage")
    const tree = {};

    permissions.forEach((permission) => {
      const parts = permission.name.split('.');
      let current = tree;

      // Build the path in the tree, creating nodes for all levels
      parts.forEach((part, index) => {
        const path = parts.slice(0, index + 1).join('.');
        const isLeaf = index === parts.length - 1;

        if (!current[part]) {
          current[part] = {
            path,
            permission: null,
            children: {},
          };
        }

        // If this is the final part of the permission name, store the permission
        if (isLeaf) {
          current[part].permission = permission;
        }

        current = current[part].children;
      });
    });

    // Convert tree to react-checkbox-tree format
    const convertNode = (node, key) => {
      const hasChildren = Object.keys(node.children).length > 0;

      // Create the node - use actual permission ID if exists, otherwise virtual
      const result = {
        value: node.permission
          ? node.permission.id.toString()
          : `virtual-${node.path}`,
        label: (
          <span title={node.permission?.description || node.path}>{key}</span>
        ),
      };

      // Add children if they exist
      if (hasChildren) {
        result.children = Object.entries(node.children)
          .sort(([a], [b]) => a.localeCompare(b))
          .map(([childKey, childNode]) => convertNode(childNode, childKey));
      }

      return result;
    };

    const nodes = Object.entries(tree)
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([key, node]) => convertNode(node, key));

    return nodes;
  };

  submitRole = (event) => {
    event.preventDefault();

    // Filter out virtual nodes and convert to numbers
    const actualPermissionIds = this.props.checks
      .filter((check) => !check.toString().startsWith('virtual-'))
      .map(Number);

    const role = {
      id: this.props.selectedRole?.id,
      name: this.props.roleName,
      [this.props.permissionsAttribute]: actualPermissionIds,
    };

    this.props.selectedRole
      ? this.props.onUpdate(role)
      : this.props.onCreate(role);
  };

  deleteRole = () => {
    this.props.openModal({
      modalTitle: `Deleting Role: ${this.props.selectedRole?.name}`,
      modalContent: (
        <ConfirmDeletion
          text={
            <span>
              Enter the word DELETE to confirm deletion.
              <br />
              <br />
              Please take in consideration that if you remove this role, it will
              affect any user that is associated to it, causing the users to
              lose permissions.
            </span>
          }
          onSubmit={() => {
            this.props.closeModal();
            this.props.onDelete(this.props.selectedRole);
          }}
          onCancel={this.props.closeModal}
        />
      ),
    });
  };

  updateChecked = (checks) => {
    // Keep all checks including virtual nodes
    // The virtual nodes help with UI display and parent selection
    this.props.updateChecks(checks);
  };

  getExpanded = (allPermissions) => {
    if (!allPermissions || allPermissions.length === 0) return [];

    // Get all nodes that have children (both real permissions and virtual nodes)
    const expanded = new Set();
    const permissionsMap = new Map();

    // Build a map of all permissions by their path
    allPermissions.forEach((permission) => {
      permissionsMap.set(permission.name, permission);
    });

    allPermissions.forEach((permission) => {
      const parts = permission.name.split('.');

      // Add all parent paths to expanded set
      for (let i = 1; i < parts.length; i++) {
        const path = parts.slice(0, i).join('.');
        const parentPermission = permissionsMap.get(path);

        // Add either the real permission ID or virtual node ID
        if (parentPermission) {
          expanded.add(parentPermission.id.toString());
        } else {
          expanded.add(`virtual-${path}`);
        }
      }
    });

    return Array.from(expanded);
  };

  render() {
    const nodes = RolesEditor.convertPermissionsForTreeview(
      this.props.allPermissions || [],
    );
    const checks = this.props.checks.map((check) => check.toString());

    return (
      <div className="role-editor-component">
        {(this.props.selectedRole?.id || this.props.newRoleMode) && (
          <div>
            <form>
              <div className="form-group row">
                <div className="col-md-12">
                  <input
                    className="form-control"
                    placeholder="Role Name"
                    value={this.props.roleName}
                    onChange={(e) => this.props.updateRoleName(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-12">
                  <div className="permissions-tree-container">
                    <CheckboxTree
                      nodes={nodes}
                      checked={checks || []}
                      expanded={this.getExpanded(this.props.allPermissions)}
                      onCheck={(checks) => this.updateChecked(checks)}
                      onExpand={(expanded) => this.setState({ expanded })}
                      showNodeIcon={false}
                      iconsClass="fa5"
                      noCascade
                    />
                  </div>
                </div>
              </div>

              {false && (
                <div className="buttons">
                  {this.props.selectedRole?.id && (
                    <Button
                      variant="danger"
                      onClick={this.deleteRole}
                      loading={this.props.deleting}
                      disabled={this.props.creating || this.props.updating}
                    >
                      Delete
                    </Button>
                  )}
                  <Button
                    type="submit"
                    variant="success"
                    loading={this.props.creating || this.props.updating}
                    disabled={this.props.deleting}
                  >
                    {this.props.selectedRole ? 'Update' : 'Create'}
                  </Button>
                </div>
              )}
            </form>
          </div>
        )}
      </div>
    );
  }
}

export default addAbilityToOpenModal(RolesEditor);
